import { FC } from "react";
import { BrowserRouter as Router, Routes } from "react-router-dom";
import * as Sentry from "@sentry/react";

import { useAuthContext } from "providers/Auth";
import { Loader } from "shared/components/Loader";

import { renderRoutes } from "./Routes/render-routes";
import { getPublicRoutes } from "./Routes/public/routes";
import { getUnauthRoutes } from "./Routes/unauth/routes";
import { getOnboardingRoutes } from "./Routes/onboarding/routes";
import { getActiveRoutes } from "./Routes/active/routes";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const RouterProvider: FC = () => {
  const { auth, permissions, type } = useAuthContext();

  if (auth === undefined)
    return (
      <div className="animate-appear pt-10 flex flex-col items-center">
        <Loader />
      </div>
    );

  const publicRoutes = getPublicRoutes();

  const getAuthRoutes = () => {
    if (!auth) return getUnauthRoutes();
    if (auth.partner.status === "active")
      return getActiveRoutes(type, permissions);
    return getOnboardingRoutes();
  };

  return (
    <Router>
      <SentryRoutes>
        {renderRoutes([...publicRoutes, ...getAuthRoutes()])}
      </SentryRoutes>
    </Router>
  );
};
